import { AgGridReact } from "ag-grid-react";
import React, {
  useEffect,
  useRef,
  useState,
  useMemo,
  forwardRef,
  useImperativeHandle,
  useCallback
} from "react";
import { AgTableClient, AgTableServer } from "app/shared/AgTable";
import { apiGet } from "app/services/apiServices";
import { handleCellRenderer } from "app/shared/AgTable/AgServerUtility";
import Loader from "app/shared/Loader";
import { Button } from "antd";
import { currentPDFData, userInfo } from "app/config/States/users";
import { useRecoilState, useSetRecoilState } from "recoil";
import { API_ENDPOINT_RECON_ZA_AIRLINE_DATA } from "app/scenes/AppTour/onboarding.constants";
import ToolParamInvoker from "app/shared/AgTable/HelperTools/ToolParamInvoker";
import {
  CheckCircleFilled,
  CloseCircleFilled,
  RightCircleOutlined,
} from "@ant-design/icons";
import { tableSchema,activeTableNameState } from "app/config/States/agtable";
import { getProcessedDefinition, getSubdomain } from "app/utils/generic.helper";
import FinkAI from "app/shared/FinkAI";
import FlightReconDemo from "../FlightReconDemo";
import { set } from "lodash";
import {
  agTableAirlineType,
  agTableAirlineData,
  tableLoadingState,
} from "app/config/States/agtable";
import {
  activeTabAtom,
  serverModeState
} from "app/config/States/users";
import { Server } from "http";
import { useRecoilValue } from "recoil";
const ChildComponent = forwardRef((props: any, ref) => {
  const [pdfViewerData, setPdfViewerData] = useState("");
  const [tableSchemaInfo, setTableSchema] = useRecoilState<any>(tableSchema);
  const [columnDefs, setColumnDefs] = useState<any[]>([]);
  const [activeTab, setActiveTab] = useRecoilState(activeTabAtom);
  const [serverPayload, setServerPayload]= useState(null)
;
const tableName = useRecoilValue(activeTableNameState);
console.log(tableName, "table name in agtable server")
  // const activeTab = localStorage.getItem("activeFlightTab");

  useEffect(() => {
    getProcessedDefinitions();
  }, [tableSchemaInfo, activeTab]);

  // Add useEffect to handle tab changes and refresh data


  useImperativeHandle(ref, () => (
    {

      createNewView(viewName: string) {
        gridRef.current?.saveGridView(viewName, props.moduleId);
      },
      loadTableView(viewId: string) {
        gridRef.current?.loadGridView(viewId, props.moduleId);
      },
      updateTableView(viewId: string) {
        gridRef.current?.updateGridView(viewId, props.moduleId);
      },
      exportDataToExcel() {
        gridRef.current?.exportDataToExcel();
      },
      getAllColumns() {
        return gridRef.current?.getAllColumns();
      },
      getGridState() {
        return gridRef.current?.getServerSidePayload();
      },
      columnApi: gridRef.current?.columnApi,
      api: gridRef.current?.api
    }));

  const [useServer, setUseServer] = useRecoilState(serverModeState);
  const [rowData, setRowData] = useState([]);
  const [isLoading, setLoading] = useState(false);
  const gridRef: any = useRef();
  const [userDetails, setUserDetails] = useRecoilState<any>(userInfo);
  const [finkDataset, setFinkDataset] = useState<any[]>([]);
  const setRecoilPdfData = useSetRecoilState<string>(currentPDFData);
  const [airlineType, setAirlineType] = useRecoilState(agTableAirlineType); //my_code
  const [airlineData, setAirlineData] = useRecoilState(agTableAirlineData);
  const [tableLoading, setTableLoading] = useRecoilState(tableLoadingState);
  const [restoreStateOnServer, setRestoreStateOnServer] = useState(false);

  const getProcessedDefinitions = () => {
    if (!tableSchemaInfo || !tableSchemaInfo.length) return [];
    let columnObject;
    if (activeTab.includes('_')) {
      const parts = activeTab.split('_');
      const index = parseInt(parts[parts.length - 1]); // Get the last part as index
      const moduleId = parts.slice(0, -1).join('_'); // Join all parts except the last one
      const matchingSchemas = tableSchemaInfo.filter((item: any) => item.moduleId === moduleId);

      if (matchingSchemas && matchingSchemas.length > 0) {
        columnObject = matchingSchemas[index] || matchingSchemas[0];
      }
    }
    if (!columnObject) {
      columnObject = tableSchemaInfo.find((item: any) => item.tableName === activeTab);
    }
    if (!columnObject) {
      columnObject = tableSchemaInfo.find((item: any) => item.moduleId === activeTab);
    }
    const columnArray = columnObject?.state?.columnDefs || [];

    const finalDefs = getProcessedDefinition(
      columnArray,
      "CLIENT",
      setRecoilPdfData,
      userDetails || {}
    );
    return finalDefs;
  };


  const domain = getSubdomain();

  const defaultFinkAction: any = [
    {
      name: "Total GST Airline Vise Not Received",
      model: {
        startRow: 0,
        endRow: 1000,
        rowGroupCols: [
          { id: "Vendor", displayName: "Vendor", field: "Vendor" },
        ],
        valueCols: [
          {
            id: "InvoiceTotalGST",
            aggFunc: "sum",
            displayName: "Invoice Total_GST",
            field: "InvoiceTotalGST",
          },
        ],
        pivotCols: [
          {
            id: "InvoiceStatus",
            displayName: "Invoice Status",
            field: "InvoiceStatus",
          },
        ],
        pivotMode: true,
        groupKeys: [],
        filterModel: {},
        sortModel: [],
        useWorkspace: false,
      },
    },
  ];
  const handleStateChange = () => {
    const state = gridRef.current.getGridState();
    setUseServer(true);
    setServerPayload(state);
    setRestoreStateOnServer(true); 
    setTimeout(() => {
      if (gridRef.current) {
        gridRef.current.loadGridView2(state);
      }
    }, 0);
  }

  return (
    <div
      className="UnReconContainer"
      style={{
        height: "100%",
        width: "100%",
        display: "flex",
        flexDirection: "column",
      }}
    >
      <div
        className="ag-theme-alpine"
        style={{ flex: 1, width: "100%", height: "100%" }}
      >
        {isLoading ||
          (tableLoading &&
            (!airlineData ||
              !(airlineData as Record<string, any[]>)[activeTab] ||
              ((airlineData as Record<string, any[]>)[activeTab] &&
                Array.isArray((airlineData as Record<string, any[]>)[activeTab]) &&
                (airlineData as Record<string, any[]>)[activeTab].length === 0))) ? (
          <div
            style={{
              height: "100%",
              width: "100%",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
            }}
          >
            <Loader />
          </div>
        ) : !useServer && airlineType === "CLIENT" ? (
          <AgTableClient
            // @ts-ignore
            rowData={(airlineData as Record<string, any[]>)[activeTab] || []}
            columnDefs={getProcessedDefinitions()}
            groupPanel
            enablePDFViewer
            pdfV2
            pdfDataKey="Invoice_link"
            ref={gridRef}
            onGridReady={(params: any) => {

              const effectiveModuleId =
                userDetails?.currentWorkspace?.meta?.dataTable || props.moduleId;

              if (
                effectiveModuleId ===
                userDetails?.currentWorkspace?.meta?.dataTable &&
                activeTab === "2"
              ) {
                params.api.setFilterModel({
                  FinancialYear: {
                    type: "equals",
                    filter: "2024-25",
                  },
                  InvoiceNoteDateMaster: {
                    type: "inRange",
                    dateFrom: "2024-04-01",
                    dateTo: "2024-09-30",
                  },
                });

                params.api.onFilterChanged();
              }
            }}
            onSelectionChanged={props.onSelectionChanged}
            onSortChanged={() => {
              handleStateChange()
            }}
            onFilterChanged={() => {
              handleStateChange()
            }}
        
            onColumnRowGroupChanged={()=>{
              handleStateChange()
            }}
            onColumnPivotModeChanged={()=>{
              handleStateChange()
            }}
            onColumnPivotChanged={()=>{
              handleStateChange()
            }}
          />
        ) : (
          <AgTableServer
            //@ts-ignore
            {...{
              key: activeTab, // Force re-mount when activeTab changes
              rowSelection: "multiple",
              columnDefs: getProcessedDefinitions(),
              endpoint: API_ENDPOINT_RECON_ZA_AIRLINE_DATA,
              // endpoint:"http://localhost:7002/api/misc/recon/za/airline",
              pdfDataKey: "Invoice_link",
              enablePDFViewer: true,
              grandTotalRow: true,
              pdfV2: true,
              ref: gridRef,
              showStatusBar: true,
              state:{serverPayload},
              restoreStateOnServer:{restoreStateOnServer},
              setRestoreStateOnServer:{setRestoreStateOnServer},
              useWorkspace:
                userDetails?.currentWorkspace?.name === "MMT Admin" ||
                userDetails?.currentWorkspace?.name === "MCKINSEY & COMPANY INC"
                  ? false
                  : userDetails?.currentWorkspace?.meta?.full_access
                    ? false
                    : true,
              moduleId: (() => {
                if (activeTab.includes("_")) {
                  const parts = activeTab.split("_");
                  return parts.slice(0, -1).join("_");
                }
                if (!tableSchemaInfo || !Array.isArray(tableSchemaInfo)) return activeTab;
                const schema = tableSchemaInfo.find(
                  (item: any) => item.tableName === activeTab || item.moduleId === activeTab
                );
                return schema?.moduleId || activeTab;
              })(),
              tableName: (() => {
                if (!tableSchemaInfo || !Array.isArray(tableSchemaInfo)) return undefined;
                const schema = tableSchemaInfo.find(
                  (item: any) => item.tableName === activeTab || item.moduleId === activeTab
                );
                return schema?.tableName || undefined;
              })(),
              setData: (data: any) => setFinkDataset(data),
              onSelectionChanged: props.onSelectionChanged,
            }}
            

          />

        )}


      </div>
      <FinkAI
        onResponse={(config: any) =>
          gridRef.current && gridRef.current.applyTestView(config)
        }
        defaultActions={defaultFinkAction}
        columnDefs={getProcessedDefinitions()}
        dataset={finkDataset}
      />
    </div>
  );
});

export default ChildComponent;